<h3 [ngStyle]="{'textAlign':textAlign}">{{titleText}}</h3>
